var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "row" },
    [
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" },
        [
          _c(
            "q-form",
            { ref: "editForm" },
            [
              _c(
                "c-card",
                {
                  staticClass: "cardClassDetailForm",
                  attrs: { title: "LBLBASEINFO" },
                },
                [
                  _c(
                    "template",
                    { slot: "card-button" },
                    [
                      _c(
                        "q-btn-group",
                        { attrs: { outline: "" } },
                        [
                          _vm.editable &&
                          !_vm.disabled &&
                          _vm.popupParam.buyRequestId
                            ? _c("c-btn", {
                                attrs: {
                                  url: _vm.completeUrl,
                                  isSubmit: _vm.isComplete,
                                  param: _vm.data,
                                  mappingType: _vm.completeType,
                                  label: "구매신청완료",
                                  icon: "save",
                                },
                                on: {
                                  beforeAction: _vm.completeData,
                                  btnCallback: _vm.completeCallback,
                                },
                              })
                            : _vm._e(),
                          _vm.editable &&
                          !_vm.disabled &&
                          _vm.popupParam.buyRequestId
                            ? _c("c-btn", {
                                attrs: {
                                  label: "LBLREMOVE",
                                  editable: _vm.editable,
                                  icon: "delete_forever",
                                },
                                on: { btnClicked: _vm.removeData },
                              })
                            : _vm._e(),
                          _vm.editable && !_vm.disabled
                            ? _c("c-btn", {
                                attrs: {
                                  url: _vm.saveUrl,
                                  isSubmit: _vm.isSave,
                                  param: _vm.data,
                                  mappingType: _vm.saveType,
                                  label: "LBLSAVE",
                                  icon: "save",
                                },
                                on: {
                                  beforeAction: _vm.saveData,
                                  btnCallback: _vm.saveCallback,
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("template", { slot: "card-detail" }, [
                    _c(
                      "div",
                      { staticClass: "col-3" },
                      [
                        _c("c-plant", {
                          attrs: {
                            required: true,
                            disabled: _vm.disabled,
                            editable: _vm.editable,
                            type: "edit",
                            name: "plantCd",
                          },
                          model: {
                            value: _vm.data.plantCd,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "plantCd", $$v)
                            },
                            expression: "data.plantCd",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-3" },
                      [
                        _c("c-datepicker", {
                          attrs: {
                            required: true,
                            label: "구매신청일",
                            default: "today",
                            disabled: _vm.disabled,
                            editable: _vm.editable,
                            name: "requestDate",
                          },
                          model: {
                            value: _vm.data.requestDate,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "requestDate", $$v)
                            },
                            expression: "data.requestDate",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-3" },
                      [
                        _c("c-dept", {
                          attrs: {
                            required: true,
                            label: "신청부서",
                            disabled: _vm.disabled,
                            editable: _vm.editable,
                            name: "requestDeptCd",
                          },
                          model: {
                            value: _vm.data.requestDeptCd,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "requestDeptCd", $$v)
                            },
                            expression: "data.requestDeptCd",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-3" },
                      [
                        _c("c-field", {
                          attrs: {
                            required: true,
                            label: "구매신청자",
                            disabled: _vm.disabled,
                            editable: _vm.editable,
                            name: "requestUserId",
                          },
                          model: {
                            value: _vm.data.requestUserId,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "requestUserId", $$v)
                            },
                            expression: "data.requestUserId",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" },
        [
          _c(
            "c-table",
            {
              ref: "table",
              attrs: {
                title: "신규 보호구 구매 신청 목록",
                tableId: "table",
                columns: _vm.grid.columns,
                data: _vm.data.detailList,
                merge: _vm.grid.merge,
                isFullScreen: false,
                columnSetting: false,
                filtering: false,
                usePaging: false,
                isExcelDown: false,
                editable: _vm.editable && !_vm.disabled,
                gridHeight: "600px",
                selection: "multiple",
                rowKey: "buyRequestDetailId",
                plantCd: _vm.data.plantCd,
              },
              on: { "table-data-change": _vm.tableDataChange },
            },
            [
              _c("template", { slot: "table-button" }, [
                _c(
                  "div",
                  [
                    _c(
                      "q-btn-group",
                      { attrs: { outline: "" } },
                      [
                        _vm.editable && !_vm.disabled
                          ? _c("c-btn", {
                              attrs: { label: "LBLADD", icon: "add" },
                              on: { btnClicked: _vm.addRow },
                            })
                          : _vm._e(),
                        _vm.editable && !_vm.disabled
                          ? _c("c-btn", {
                              attrs: { label: "LBLEXCEPT", icon: "remove" },
                              on: { btnClicked: _vm.removeRow },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ],
            2
          ),
        ],
        1
      ),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }